import React, { Component } from "react";
import { Row, Col, Image, Accordion, Card, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import RejectIcon from "../../../assets/images/RejectIcon.svg";
import approved from "../../../assets/images/approved.svg";
import CaretCircleDownAccordion from "../../../assets/images/CaretCircleDownAccordion.svg";
import delivaApiService from "../../../common/services/apiService";
import validateInput from "../../../common/validations/validateDetailsPA";
import { showErrorToast, getLocalStorage } from "../../../common/helpers/Utils";
import "./ProcessingAgentDetails.scss";

class ProcessingAgentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: null,
      showRejectModal: false,
      passportVerification: false,
      bankVerification: false,
      timeVerification: false,
      idproofVerification: false,
      adminVerification: false,
      businessVerification: false,
      termsVerification: false,
      notarionVerification: false,
      internationalVerification: false,
      rejectionType: "resubmission", // 'resubmission' or 'block'
      errors: {},
      rejectionReason: "Other",
      successModal: false,
      showLoader: false,
      selectedParcelCenter: null,
      rejectionSection: null,
      rejectionParcelCenterId: null,
    };
  }

  handleReject = (userId) => {
    this.setState({
      showRejectModal: !this.state.showRejectModal,
      userId,
      rejectionSection: null,
      rejectionParcelCenterId: null,
    });
  };

  handleSectionReject = (userId, parcelCenter, section) => {
    this.setState({
      showRejectModal: true,
      userId,
      rejectionSection: section,
      rejectionParcelCenterId: parcelCenter?.parcelCenterId || parcelCenter?.id,
      rejectionReason: "Other",
      description: "",
    });
  };

  handleBlock = (userId) => {
    // TODO: Implement block functionality
    console.log("Block user:", userId);
    // Add API call to block the user
    // delivaApiService("blockPA", { userId })
    //   .then((response) => {
    //     if (response.data.status === 200) {
    //       showSuccessToast("User blocked successfully");
    //       this.props.history.push("/verification/4");
    //     }
    //   })
    //   .catch((error) => {
    //     showErrorToast("Failed to block user");
    //   });
  };

  componentDidMount() {
    if (this.props && this.props.location.state.item) {
      this.getProcessingAgentDetail();
    }
  }

  approveDA = (userId, name) => {
    this.setState({ showLoader: true, daName: name, userId });
    delivaApiService("approveDA", {
      userId,
      isKycVerifiedByAdmin: true,
      verificationDetailsByAdmin: "",
    })
      .then((response) => {
        this.setState({ showLoader: false, successModal: true });
        if (response.data.status === 200) {
          this.getProcessingAgentDetail();
          this.setState({ errors: {} });
        }
      })
      .catch(() => {
        this.setState({ showLoader: false });
      });
  };

  updateParcelCenterSectionStatus = (
    parcelCenter,
    section,
    status,
    rejectionDetails = {},
  ) => {
    const parcelCenterId = parcelCenter?.parcelCenterId || parcelCenter?.id;

    this.setState({ showLoader: true });
    delivaApiService("updateParcelCenterSectionStatus", {
      parcelCenterId,
      section,
      status,
      ...rejectionDetails,
    })
      .then((response) => {
        this.setState({ showLoader: false });
        if (response.data.status === 200) {
          this.getProcessingAgentDetail();
          this.setState({ errors: {} });
        }
      })
      .catch(() => {
        this.setState({ showLoader: false });
      });
  };

  approvalSuccessModal = () => {
    this.setState({
      successModal: !this.state.successModal,
    });
    this.props.history.push("/verification/4");
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
      ...(name === "rejectionReason" && value !== "Other"
        ? { description: "" }
        : {}),
    });
  };

  setLoader(showLoader) {
    this.setState({
      showLoader,
    });
  }

  getProcessingAgentDetail() {
    this.setLoader(true);
    delivaApiService("getProcessingAgentDetail", {
      id: this.props.location.state.item.userId,
    })
      .then((response) => {
        if (response && response.data && response.data.resourceData) {
          const data = response.data.resourceData;
          const parcelCenters = Array.isArray(data.parcelCenters)
            ? data.parcelCenters
            : [];
          this.setState({
            details: data,
            selectedParcelCenter: data.parcelCenter || parcelCenters[0] || null,
          });
          this.setLoader(false);
        } else {
          this.setLoader(false);
        }
      })
      .catch((err) => {
        this.setLoader(false);
      });
  }

  operatingTime = (week, source = null) => {
    const dataSource = source || this.state.details;
    let operatingTime = "Closed";
    const days = dataSource?.operationalHours?.days;

    if (Array.isArray(days)) {
      const dayInfo = days.find(
        (item) =>
          item?.dayName?.trim().toUpperCase() === week.trim().toUpperCase(),
      );

      if (
        dayInfo &&
        (dayInfo.open === true || String(dayInfo.open).toLowerCase() === "true")
      ) {
        operatingTime = `${dayInfo.startTime} - ${dayInfo.endTime}`;
      }
    }

    return operatingTime;
  };

  getVerificationStatus = (status) => {
    const statusMap = {
      NOT_STARTED: "Not Started",
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      DRAFT: "Draft",
    };
    return statusMap[status] || status;
  };

  getParcelCenterStatus = (parcelCenter) => {
    if (parcelCenter?.active || parcelCenter?.status === "APPROVED") {
      return "Approved";
    }
    if (parcelCenter?.status === "REJECTED") {
      return "Rejected";
    }
    return "Pending";
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    console.log(isValid);
    return isValid;
  }

  submitReject = () => {
    if (
      this.state.rejectionReason &&
      (this.state.rejectionReason !== "Other" || this.state.description) &&
      this.state.userId
    ) {
      let data = {
        reasonForRejection: this.state.rejectionReason,
        rejectionDetail:
          this.state.rejectionReason === "Other" ? this.state.description : "",
        userId: this.state.userId,
        isDocsResubmissionBlocked:
          this.state.rejectionType === "block" ? true : false,
      };
      if (this.state.rejectionSection && this.state.rejectionParcelCenterId) {
        const adminUserId = Number(getLocalStorage("id")) || this.state.userId;

        delivaApiService("updateParcelCenterSectionStatus", {
          parcelCenterId: this.state.rejectionParcelCenterId,
          adminUserId,
          rejectionAction:
            this.state.rejectionType === "block" ? "BLOCK" : "RESUBMISSION",
          rejectionDetail: this.state.rejectionReason,
          rejectionReason:
            this.state.rejectionReason === "Other"
              ? this.state.description
              : this.state.rejectionReason || "",
          section: this.state.rejectionSection,
          status: "REJECTED",
        })
          .then((response) => {
            this.setState({ showLoader: false });
            if (response.data.status === 200) {
              this.setState({
                showRejectModal: false,
                rejectionSection: null,
                rejectionParcelCenterId: null,
              });
              this.getProcessingAgentDetail();
            }
          })
          .catch(() => {
            this.setState({ showLoader: false });
          });
        return;
      }
      delivaApiService("rejectDA", data)
        .then((response) => {
          this.setState({ showLoader: false });
          if (response.data.status === 200) {
            this.setState({
              showRejectModal: !this.state.showRejectModal,
            });
            this.props.history.push("/verification/4");
            this.getProcessingAgentDetail(data.userId);
          }
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
        });
    } else {
      showErrorToast("Please write rejection details");
    }
  };
  render() {
    const { details, errors, selectedParcelCenter } = this.state;

    if (!details) {
      return null;
    }

    const parcelCenters =
      Array.isArray(details.parcelCenters) && details.parcelCenters.length
        ? details.parcelCenters
        : details.parcelCenter
          ? [details.parcelCenter]
          : [];
    const parcelCenter = selectedParcelCenter || parcelCenters[0];
    const adminVerification = details.administratorVerification;
    const isAdminApproved = adminVerification?.status === "APPROVED";

    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper pa-verification-details">
                  <Row noGutters className="mb-3 align-items-center">
                    <Col md={6} lg={8} className="">
                      <h3 className="font-weight-normal fs-24 mb-0 line-ht color-33">
                        {details?.businessName || parcelCenter?.name || ""}
                      </h3>
                      <h5 className="font-weight-normal mb-0 fs18 line-ht color-grey">
                        <span
                          onClick={() =>
                            this.props.history.push("/verification/4")
                          }
                          className="pointer"
                        >
                          Parcel centres
                        </span>
                        <span className="icon-next mx-2 Fs12"></span>
                        {details?.businessName || parcelCenter?.name || ""}
                      </h5>
                    </Col>
                    <Col md={6} lg={4} className="text-right">
                      <button className="yellow-text-btn fs20">
                        {details && Object.keys(details).length > 0 && (
                          <button
                            className={`${
                              details.rejected ? "color-red" : "color-blue"
                            } background-none border-none fs20`}
                          >
                            {details.rejected
                              ? "Rejected"
                              : details.active
                                ? "In-process"
                                : "Pending"}
                          </button>
                        )}
                      </button>
                    </Col>
                  </Row>

                  {/* Administrator Verification */}
                  {adminVerification && (
                    <>
                      <div className="details-wrap verification-card mb-3">
                        <Row noGutters>
                          <Col md={12}>
                            <h5 className="px-4">Administrator verification</h5>
                            <hr />
                          </Col>
                        </Row>
                        <div className="px-4 pb-3">
                          <Row className="mb-3">
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Full Name
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                {adminVerification.fullName ||
                                  "Adebayo cornelius"}
                              </h5>
                            </Col>
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Status
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                <span
                                  className={
                                    adminVerification.status === "APPROVED"
                                      ? "color-green"
                                      : adminVerification.status === "REJECTED"
                                        ? "color-red"
                                        : "color-orange"
                                  }
                                >
                                  {this.getVerificationStatus(
                                    adminVerification.status,
                                  )}
                                </span>
                              </h5>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-2">
                                Personal govt ID
                              </h5>
                              <div className="verification-img-container">
                                {adminVerification.govtIdImageUrls &&
                                adminVerification.govtIdImageUrls.length > 0 ? (
                                  <Image
                                    src={adminVerification.govtIdImageUrls[0]}
                                    alt="Government ID"
                                    className="img-fluid"
                                  />
                                ) : (
                                  <div className="placeholder-img">
                                    No image
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-2">
                                Selfie
                              </h5>
                              <div className="verification-img-container">
                                {adminVerification.selfieImageUrl ? (
                                  <Image
                                    src={adminVerification.selfieImageUrl}
                                    alt="Selfie"
                                    className="img-fluid"
                                  />
                                ) : (
                                  <div className="placeholder-img">
                                    No image
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          {!isAdminApproved && (
                            <>
                              <Row className="mb-2">
                                <Col md={12}>
                                  <div className="checkboxContainer">
                                    <input
                                      type="checkbox"
                                      id="adminVerify"
                                      name="adminVerification"
                                      checked={this.state.adminVerification}
                                      onChange={this.onChange}
                                    />
                                    <label
                                      htmlFor="adminVerify"
                                      className="input-label"
                                    >
                                      Verify by admin
                                    </label>
                                  </div>
                                </Col>
                              </Row>
                              {this.state.adminVerification && (
                                <Row>
                                  <Col md={12} className="d-flex mt-4 mb-1">
                                    <button
                                      className="df-button danger mr-3"
                                      onClick={this.handleReject.bind(
                                        this,
                                        details.userId,
                                      )}
                                    >
                                      Reject
                                    </button>
                                    <button
                                      className="df-button success"
                                      // disabled={details.active}
                                      onClick={
                                        // !details.active
                                        //   ?
                                        this.approveDA.bind(
                                          this,
                                          details.userId,
                                          details.businessName,
                                        )
                                        // : undefined
                                      }
                                    >
                                      Approve
                                    </button>
                                  </Col>
                                </Row>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      {!details.active && errors.adminVerification && (
                        <Row className="mb-3">
                          <Col md={12} className="text-center">
                            <p className="color-red fs14 mb-0">
                              {errors.adminVerification}
                            </p>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}

                  {/* T&C Agreement */}
                  {/* {termsAgreement && (
                    <>
                      <div className="details-wrap verification-card mb-3">
                        <Row noGutters>
                          <Col md={12}>
                            <h5 className="px-4">T&C Agreement</h5>
                            <hr />
                          </Col>
                        </Row>
                        <div className="px-4 pb-3">
                          <Row className="mb-3">
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">Status</h5>
                              <h5 className="fs16 font-weight-normal">
                                {termsAgreement.accepted ? 'Accepted' : 'Not Accepted'}
                              </h5>
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col md={12}>
                              <div className="checkboxContainer">
                                <input
                                  type="checkbox"
                                  id="termsVerify"
                                  name="termsVerification"
                                  checked={this.state.termsVerification}
                                  onChange={this.onChange}
                                  disabled={details.active}
                                />
                                <label htmlFor="termsVerify" className="input-label">
                                  {details.active ? 'Verified by admin' : 'Verify by admin'}
                                </label>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      {!details.active && errors.termsVerification && (
                        <Row className="mb-3">
                          <Col md={12} className="text-center">
                            <p className="color-red fs14 mb-0">{errors.termsVerification}</p>
                          </Col>
                        </Row>
                      )}
                    </>
                  )} */}

                  {/* Personal Details */}
                  {/*<div className="details-wrap mb-4">
                    <Row noGutters>
                      <Col md={12} lg={12} className="">
                        <h5 className="px-4">Personal Details</h5>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="px-4">
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Name</h5>
                        <h5 className="fs16 font-weight-normal">
                          {details.bankingDetails?.fullName || details.businessName || "Test User"}
                        </h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Partner ID</h5>
                        <h5 className="fs16 font-weight-normal">#{details.userId}</h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Date of Registration</h5>
                        <h5 className="fs16 font-weight-normal">
                          {moment(this.props.location?.state?.item?.createdDate).format("DD MMM YYYY")}
                        </h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Contact</h5>
                        <h5 className="fs16 font-weight-normal">
                          {details.countryCode && details.mobile ? `+${details.countryCode}-${details.mobile}` : ""}
                        </h5>
                      </Col>
                    </Row>
                    <hr />
                    <Row className="px-4">
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Email</h5>
                        <h5 className="fs16 font-weight-normal">{details.email}</h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Name</h5>
                        <h5 className="fs16 font-weight-normal">
                          {parcelCenter?.name || details.businessName || ""}
                        </h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Business Type</h5>
                        <h5 className="fs16 font-weight-normal">
                          {parcelCenter?.businessType || details.businessType || ""}
                        </h5>
                      </Col>
                      <Col md={3} className="mb-3">
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Business Reg No</h5>
                        <h5 className="fs16 font-weight-normal">
                          {parcelCenter?.registrationNumber || details.businessRegistrationNumber || ""}
                        </h5>
                      </Col>
                    </Row>
                    <hr />
                    <Row className="px-4">
                      <Col md={12}>
                        <h5 className="font-weight-normal color-grey fs14 mb-1">Address</h5>
                        <h5 className="fs16 font-weight-normal">
                          {parcelCenter?.address || 
                            (details.bussinessAddress &&
                            [
                              details.bussinessAddress.aptNumber,
                              details.bussinessAddress.address,
                              details.bussinessAddress.city,
                              details.bussinessAddress.state,
                              details.bussinessAddress.country
                            ].filter(Boolean).join(", "))}
                        </h5>
                      </Col>
                    </Row>
                  </div>*/}

                  {/* Parcel center details */}
                  <Accordion
                    defaultActiveKey={
                      parcelCenters.length
                        ? String(
                            parcelCenters[0].parcelCenterId ||
                              parcelCenters[0].id ||
                              0,
                          )
                        : undefined
                    }
                    className="mb-3"
                  >
                    {parcelCenters.map((parcelCenter, centerIndex) => {
                      const businessVerification =
                        parcelCenter.businessVerification;
                      const centerKey = String(
                        parcelCenter.parcelCenterId ||
                          parcelCenter.id ||
                          centerIndex,
                      );
                      const centerStatus =
                        this.getParcelCenterStatus(parcelCenter);
                      const centerStatusClass =
                        centerStatus === "Approved"
                          ? "color-green"
                          : centerStatus === "Rejected"
                            ? "color-red"
                            : "color-orange";
                      const nationalStatus =
                        businessVerification?.status || "PENDING";
                      const internationalStatus =
                        businessVerification?.internationalStatus || "PENDING";

                      return (
                        <Card className="details-wrap mb-3" key={centerKey}>
                          <Card.Header className="px-4 py-3 border-0 bg-transparent">
                            <Accordion.Toggle
                              as={Button}
                              variant="link"
                              eventKey={centerKey}
                              className="w-100 text-left p-0 text-decoration-none"
                            >
                              <span className="fs16 font-weight-bold color-33">
                                {parcelCenter.name}
                              </span>
                              <span
                                className={`${centerStatusClass} fs14 ml-2`}
                              >
                                - {centerStatus}
                              </span>
                              <Image
                                src={CaretCircleDownAccordion}
                                alt=""
                                className="img-fluid float-right accordion-arrow"
                              />
                            </Accordion.Toggle>
                          </Card.Header>
                          <Accordion.Collapse eventKey={centerKey}>
                            <Card.Body className="p-0">
                              <div className="mb-3">
                                <Row className="px-4 mb-3">
                                  <Col md={2} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Business name
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.name}
                                    </h5>
                                  </Col>
                                  <Col md={2} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Business type
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.businessType || "N/A"}
                                    </h5>
                                  </Col>
                                  <Col md={2} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Mobile number
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.countryCode}{" "}
                                      {parcelCenter.mobile}
                                    </h5>
                                  </Col>
                                  <Col md={3} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Email
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.email}
                                    </h5>
                                  </Col>
                                  <Col md={3} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Parcel center capacity
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.capacity || "N/A"}
                                    </h5>
                                  </Col>
                                </Row>
                                <Row className="px-4 mb-3">
                                  <Col md={2} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Request type
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.requestTypes || "N/A"}
                                    </h5>
                                  </Col>
                                  <Col md={5} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Address
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.address || "N/A"}
                                    </h5>
                                  </Col>
                                  <Col md={5} className="mb-3">
                                    <h5 className="font-weight-normal color-grey fs14 mb-1">
                                      Addition address
                                    </h5>
                                    <h5 className="fs16 font-weight-normal">
                                      {parcelCenter.additionalAddress || "N/A"}
                                    </h5>
                                  </Col>
                                </Row>

                                {/* Photos */}
                                {parcelCenter.photoUrls &&
                                  parcelCenter.photoUrls.length > 0 && (
                                    <>
                                      <Row noGutters>
                                        <Col md={12}>
                                          <h5 className="px-4 color-grey fs14 mb-2">
                                            Parcel center photo
                                          </h5>
                                        </Col>
                                      </Row>
                                      <Row className="px-4 mb-3">
                                        {parcelCenter.photoUrls
                                          .slice(0, 4)
                                          .map((url, idx) => (
                                            <Col
                                              xs={6}
                                              md={3}
                                              key={idx}
                                              className="mb-3"
                                            >
                                              <Image
                                                src={url}
                                                alt={`Parcel center ${idx + 1}`}
                                                className="img-fluid parcel-photo"
                                              />
                                            </Col>
                                          ))}
                                      </Row>
                                    </>
                                  )}
                              </div>

                              {/* Team of parcel center */}
                              <div className="mb-3">
                                <Row noGutters>
                                  <Col md={12}>
                                    <h5 className="px-4 pt-3 mb-2">
                                      Team of parcel center
                                    </h5>
                                  </Col>
                                </Row>
                                {parcelCenter.team &&
                                  parcelCenter.team.length > 0 && (
                                    <div className="px-4 pb-3">
                                      <div className="table-responsive">
                                        <table className="table team-table">
                                          <thead>
                                            <tr>
                                              <th>ID</th>
                                              <th>Type</th>
                                              <th>Name</th>
                                              <th>Email ID</th>
                                              <th>Mobile no.</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {parcelCenter.team.map(
                                              (member, idx) => (
                                                <tr key={idx}>
                                                  <td>#{member.id}</td>
                                                  <td>{member.type}</td>
                                                  <td>{member.name || "-"}</td>
                                                  <td>{member.email}</td>
                                                  <td>
                                                    {member.countryCode}{" "}
                                                    {member.mobile}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                              </div>

                              {/* Operational hours and banking details */}
                              <div className="mb-3">
                                {/* <Row noGutters>
                                  <Col md={12}>
                                    <h5 className="px-4 pt-3 mb-2">
                                      Operational Hours &amp; Banking Details
                                    </h5>
                                  </Col>
                                </Row> */}
                                <Row className="px-4 mb-3">
                                  <Col md={6}>
                                    <h5 className="mb-3">Operational hours</h5>
                                    <div className="row m-0">
                                      <div className="col-6 px-0">
                                        <ul className="hrs-list">
                                          {[
                                            "Monday",
                                            "Tuesday",
                                            "Wednesday",
                                            "Thursday",
                                          ].map((day) => (
                                            <li key={day}>
                                              <div className="row">
                                                <div className="col-5">
                                                  <span className="color-grey fs14">
                                                    {day}
                                                  </span>
                                                </div>
                                                <div className="col-7 text-right fw500 fs14">
                                                  {this.operatingTime(
                                                    day,
                                                    parcelCenter,
                                                  )}
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                      <div className="col-6 px-0">
                                        <ul className="hrs-list">
                                          {["Friday", "Saturday", "Sunday"].map(
                                            (day) => (
                                              <li key={day}>
                                                <div className="row">
                                                  <div className="col-5">
                                                    <span className="color-grey fs14">
                                                      {day}
                                                    </span>
                                                  </div>
                                                  <div className="col-7 text-right fw500 fs14">
                                                    {this.operatingTime(
                                                      day,
                                                      parcelCenter,
                                                    )}
                                                  </div>
                                                </div>
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <h5 className="mb-3">Banking details</h5>
                                    <Row>
                                      <Col md={6} className="mb-3">
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          Full Name
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {(
                                            parcelCenter?.bankingDetails ||
                                            details.bankingDetails
                                          )?.fullName || ""}
                                        </h5>
                                      </Col>
                                      <Col md={6} className="mb-3">
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          Account number
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {(
                                            parcelCenter?.bankingDetails ||
                                            details.bankingDetails
                                          )?.accountNumber || ""}
                                        </h5>
                                      </Col>
                                      <Col md={6} className="mb-3">
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          Bank
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {(
                                            parcelCenter?.bankingDetails ||
                                            details.bankingDetails
                                          )?.bankName || ""}{" "}
                                          {(
                                            parcelCenter?.bankingDetails ||
                                            details.bankingDetails
                                          )?.bankLocation || ""}
                                        </h5>
                                      </Col>
                                      <Col md={6} className="mb-3">
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          ABA Number
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {(
                                            parcelCenter?.bankingDetails ||
                                            details.bankingDetails
                                          )?.abaNumber || "N/A"}
                                        </h5>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </div>

                              {businessVerification && (
                                <>
                                  <div className="mb-4 px-3">
                                    <Row noGutters className="px-1">
                                      <Col md={12}>
                                        <h5 className="px-2 mb-2">
                                          Business verification
                                        </h5>
                                        <hr className="my-2" />
                                      </Col>
                                    </Row>
                                    <Row className="px-2 mb-3">
                                      <Col md={6}>
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          Business name
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {businessVerification.businessName ||
                                            parcelCenter.name}
                                        </h5>
                                      </Col>
                                      <Col md={6}>
                                        <h5 className="font-weight-normal color-grey fs14 mb-1">
                                          Business registration number
                                        </h5>
                                        <h5 className="fs16 font-weight-normal">
                                          {businessVerification.businessRegistrationNumber ||
                                            parcelCenter.registrationNumber ||
                                            details.businessRegistrationNumber ||
                                            "N/A"}
                                        </h5>
                                      </Col>
                                    </Row>

                                    {/* Natation documents */}
                                    <div className="border rounded mb-3 p-3 mx-1">
                                      <Row className="px-0 mb-2">
                                        <Col md={12}>
                                          <h5 className="font-weight-normal fs14 mb-1">
                                            National business documents
                                            <span
                                              className={`${nationalStatus === "APPROVED" ? "color-green" : nationalStatus === "REJECTED" ? "color-red" : "color-orange"} fs14 ml-2`}
                                            >
                                              -{" "}
                                              {this.getVerificationStatus(
                                                nationalStatus,
                                              )}
                                            </span>
                                          </h5>
                                        </Col>
                                      </Row>
                                      <Row className="px-0 mb-3">
                                        {businessVerification.businessDocumentUrls &&
                                        businessVerification
                                          .businessDocumentUrls.length > 0 ? (
                                          businessVerification.businessDocumentUrls
                                            .slice(0, 4)
                                            .map((url, idx) => (
                                              <Col
                                                xs={6}
                                                md={3}
                                                key={idx}
                                                className="mb-2"
                                              >
                                                <Image
                                                  src={url}
                                                  alt={`Business document ${idx + 1}`}
                                                  className="img-fluid doc-preview"
                                                />
                                              </Col>
                                            ))
                                        ) : (
                                          <Col md={12}>
                                            <p className="text-muted fs14">
                                              No documents
                                            </p>
                                          </Col>
                                        )}
                                      </Row>
                                      {nationalStatus !== "APPROVED" &&
                                        adminVerification.status ===
                                          "APPROVED" &&
                                        nationalStatus === "PENDING" && (
                                          <Row className="px-0 mb-1">
                                            <Col
                                              md={12}
                                              className="d-flex mt-4 mb-1"
                                            >
                                              <button
                                                className="df-button danger mr-3"
                                                onClick={this.handleSectionReject.bind(
                                                  this,
                                                  details.userId,
                                                  parcelCenter,
                                                  "businessDocuments",
                                                )}
                                              >
                                                Reject
                                              </button>
                                              <button
                                                className="df-button success"
                                                onClick={this.updateParcelCenterSectionStatus.bind(
                                                  this,
                                                  parcelCenter,
                                                  "businessDocuments",
                                                  "APPROVED",
                                                )}
                                              >
                                                Approve
                                              </button>
                                            </Col>
                                          </Row>
                                        )}
                                    </div>

                                    {/* International documents */}
                                    {businessVerification.internationalBusiness && (
                                      <div className="border rounded p-3 mt-3 mx-1">
                                        <Row className="px-0 mb-2">
                                          <Col md={12}>
                                            <h5 className="font-weight-normal fs14 mb-1">
                                              International business documents
                                              <span
                                                className={`${internationalStatus === "APPROVED" ? "color-green" : internationalStatus === "REJECTED" ? "color-red" : "color-orange"} fs14 ml-2`}
                                              >
                                                -{" "}
                                                {this.getVerificationStatus(
                                                  internationalStatus,
                                                )}
                                              </span>
                                            </h5>
                                          </Col>
                                        </Row>
                                        <Row className="px-0 mb-3">
                                          {businessVerification.internationalDocumentUrls &&
                                          businessVerification
                                            .internationalDocumentUrls.length >
                                            0 ? (
                                            businessVerification.internationalDocumentUrls
                                              .slice(0, 4)
                                              .map((url, idx) => (
                                                <Col
                                                  xs={6}
                                                  md={3}
                                                  key={idx}
                                                  className="mb-2"
                                                >
                                                  <Image
                                                    src={url}
                                                    alt={`International document ${idx + 1}`}
                                                    className="img-fluid doc-preview"
                                                  />
                                                </Col>
                                              ))
                                          ) : (
                                            <Col md={12}>
                                              <p className="text-muted fs14">
                                                No documents
                                              </p>
                                            </Col>
                                          )}
                                        </Row>
                                        {internationalStatus !== "APPROVED" &&
                                          adminVerification.status ===
                                            "APPROVED" &&
                                          internationalStatus === "PENDING" && (
                                            <Row className="px-0 mb-1">
                                              <Col
                                                md={12}
                                                className="d-flex mt-4 mb-1"
                                              >
                                                <button
                                                  className="df-button danger mr-3"
                                                  onClick={this.handleSectionReject.bind(
                                                    this,
                                                    details.userId,
                                                    parcelCenter,
                                                    "internationalBusinessDocuments",
                                                  )}
                                                >
                                                  Reject
                                                </button>
                                                <button
                                                  className="df-button success"
                                                  onClick={this.updateParcelCenterSectionStatus.bind(
                                                    this,
                                                    parcelCenter,
                                                    "internationalBusinessDocuments",
                                                    "APPROVED",
                                                  )}
                                                >
                                                  Approve
                                                </button>
                                              </Col>
                                            </Row>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      );
                    })}
                  </Accordion>
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>
        <Modal
          show={this.state.showRejectModal}
          onHide={this.handleReject.bind(this, "")}
          centered
          className="deliva-popup"
        >
          <Modal.Body>
            <div className="modal-content-wrap">
              <div className="text-center">
                <Image src={RejectIcon} className="img-fluid reject-img" />
                <h4 className="color-red mt-3 fs-22">
                  Are you sure to reject this request ?
                </h4>
                <p className="color-head">
                  Please add/choose the reason of rejection
                </p>
              </div>

              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label className="color-head">
                  Choose the Reason
                </Form.Label>
                <Form.Control
                  as="select"
                  name="rejectionReason"
                  onChange={this.onChange}
                  value={this.state.rejectionReason}
                  className="py-0"
                >
                  <option value="Other">Other</option>
                  <option value="Invalid Passport Details">
                    Invalid Passport Details
                  </option>
                  <option value="Invalid Banking Details">
                    Invalid Banking Details
                  </option>
                  <option value="Invalid ID Proof">Invalid ID Proof</option>
                  <option value="Criminal Background">
                    Criminal Background
                  </option>
                </Form.Control>
              </Form.Group>

              {this.state.rejectionReason === "Other" && (
                <Form.Group controlId="exampleForm.ControlTextarea1">
                  <Form.Label className="color-head">
                    Rejection details
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    name="description"
                    onChange={this.onChange}
                    maxLength="100"
                    placeholder="Write rejection details..."
                  />
                  <span className="min-char d-block">Max 100 chars</span>
                </Form.Group>
              )}

              <div className="text-left mb-4">
                <div className="mb-2">Action</div>
                <label className="modal-radio-wrap mr-4">
                  <input
                    type="radio"
                    name="rejectionType"
                    className="modal-radio-input"
                    checked={this.state.rejectionType === "resubmission"}
                    onChange={() =>
                      this.setState({ rejectionType: "resubmission" })
                    }
                  />
                  <span className="modal-radio-label">Resubmission</span>
                </label>
                <label className="modal-radio-wrap">
                  <input
                    type="radio"
                    name="rejectionType"
                    className="modal-radio-input"
                    checked={this.state.rejectionType === "block"}
                    onChange={() => this.setState({ rejectionType: "block" })}
                  />
                  <span className="modal-radio-label">Block</span>
                </label>
              </div>

              <div className="text-center mt-4">
                <button
                  className="cancel-btn min-w-80 mr-4"
                  onClick={this.handleReject.bind(this, "")}
                >
                  No
                </button>
                <button
                  className="b1-btn min-w-80"
                  onClick={this.submitReject.bind(this)}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.successModal}
          onHide={() => this.approvalSuccessModal(this)}
          centered
        >
          <Modal.Body>
            <div className="modal-content-wrap text-center">
              <Image src={approved} className="img-fluid user-block-img" />
              <h4 className="lightGreenTex mt-3">Approved</h4>
              <p className="color-grey">
                {this.state.daName} #{this.state.userId} detail are approved
              </p>

              <button
                className="b1-btn min-w-80"
                onClick={() => this.approvalSuccessModal(this)}
              >
                Back
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ProcessingAgentDetails;
